import { Tooltip } from "@mui/material";
import Iconify from "../Iconify";

export interface IProps {
  title: any;
  color?: string;
  placement?:
    | "top"
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | undefined;
  sx?: any;
  children?: any;
}

export default ({
  title,
  color = "grey.500",
  placement = "top",
  sx = {},
  children,
}: IProps) => {
  return (
    <Tooltip
      placement={placement}
      arrow
      title={title}
      enterTouchDelay={0}
      leaveTouchDelay={3000}
    >
      {children ? (
        children
      ) : (
        <Iconify
          icon={"fluent:info-24-filled"}
          color={color}
          sx={{
            height: "20px",
            width: "20px",
            zIndex: 1000,
            ...sx,
          }}
        />
      )}
    </Tooltip>
  );
};
